import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// Replaces the default sign-in page. The page is imported on first render, so
// its code stays out of the initial bundle.
export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: () =>
      import('../components/signin/XelerateSignInPage').then(
        m => m.XelerateSignInPage,
      ),
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
